import Newsletter from 'umg-ember-backend/components/record-explorer/for/newsletter';

<template>
  <Newsletter @records={{@model}} @recordType='newsletter-target' />
</template>
